
    import '/home/ec2-user/Youlify-Design/components/divider/index.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["divider-demo-horizontal","divider-demo-with-text","divider-demo-plain","divider-demo-vertical","divider-demo-customize-style","divider-demo-component-token","divider-demo-variant"],
  getter: () => import(/* webpackChunkName: "meta__components__en-US" */'/home/ec2-user/Youlify-Design/components/divider/index.en-US.md?type=demo')
};